import type { TTicketData, TTicketMessage } from '@cascade/api-client/shared';
import type {
  TGetTicketRequestPayload,
  TListProjectLabelsRequestPayload,
  TListTicketsRequestPayload,
  TListTicketsResponsePayload,
} from '@cascade/api-client/ticketing';
import type { THasCascadeTicketingRequestPayload } from '@cascade/api-client/ticketing-integrations';
import { createQueryKey } from '#providers/query/index.ts';
import type { TQueryKeyPrefix } from '#providers/query/index.ts';

export const ticketsQueryPrefix = [
  'ticketing',
  'listTickets',
] as const satisfies TQueryKeyPrefix<'ticketing'>;

export const ticketQueryPrefix = [
  'ticketing',
  'getTicket',
] as const satisfies TQueryKeyPrefix<'ticketing'>;

export const ticketQueryPrefixes = [ticketsQueryPrefix, ticketQueryPrefix];

export const labelsQueryPrefix = [
  'ticketing',
  'listProjectLabels',
] as const satisfies TQueryKeyPrefix<'ticketing'>;

export const getTicketingQueryKey = (
  payload: THasCascadeTicketingRequestPayload,
) => createQueryKey('ticketingIntegrations', 'hasCascadeTicketing', payload);

export const getTicketsQueryKey = (payload: TListTicketsRequestPayload) =>
  createQueryKey('ticketing', 'listTickets', payload);

export const getTicketQueryKey = (payload: TGetTicketRequestPayload) =>
  createQueryKey('ticketing', 'getTicket', payload);

export const getLabelsQueryKey = (payload: TListProjectLabelsRequestPayload) =>
  createQueryKey('ticketing', 'listProjectLabels', payload);

export const getNextTicketsPage = ({
  page,
  page_size: pageSize,
  total_count: totalCount,
}: TListTicketsResponsePayload): number | undefined =>
  page * pageSize < totalCount ? page + 1 : undefined;

export const hasAttachments = (files?: Blob[]): files is Blob[] =>
  files !== undefined && files.length > 0;

export const getTicketConversationId = (
  ticket?: TTicketData,
): string | undefined =>
  ticket?.references?.find((reference) => reference.type === 'conversation')
    ?.id;

export const hasUnreadFromOthers = (
  messages: TTicketMessage[] = [],
  userId: string,
): boolean =>
  messages.some((message) => !message.is_read && message.sender_id !== userId);
